// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileImageOutlinedSvg from "@fishx/icons-svg/es/asn/PFileImageOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileImageOutlined = function PFileImageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileImageOutlinedSvg
  }));
};

PFileImageOutlined.displayName = 'PFileImageOutlined';
export default React.forwardRef(PFileImageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileImageOutlined.js
// module id = 3392
// module chunks = 0